// Mock data for Alakhe Conglomerate website - Updated for new brand

export const companyInfo = {
  name: "ALAKHE CONGLOMERATE",
  tagline: "Driving Value, Adding Solutions",
  founded: "2018",
  yearsExperience: new Date().getFullYear() - 2018,
  location: "Reitz, Free State, South Africa",
  registration: "2018/060750/07",
  email: {
    admin: "admin@alakhecgl.com",
    director: "yakatshepo.m@gmail.com"
  },
  phone: "072 546 2612",
  whatsapp: "27725462612",
  address: "273 Petsana, Nketoana Township, Reitz, Free State",
  description: "We deliver innovative, reliable, and sustainable solutions across multiple industries, helping businesses and communities grow through quality, integrity, and excellence."
};

export const services = [
  {
    id: 1,
    title: "Construction",
    description: "Comprehensive construction services for residential and commercial projects, delivering quality infrastructure with precision and expertise.",
    icon: "Building2",
    features: [
      "Residential Construction",
      "Commercial Buildings",
      "Road Infrastructure",
      "Quality Assurance"
    ]
  },
  {
    id: 2,
    title: "Civil Engineering",
    description: "Advanced civil engineering solutions including water infrastructure, road networks, and sustainable development projects.",
    icon: "HardHat",
    features: [
      "Water infrastructure",
      "Road networks",
      "Sustainable design",
      "Project planning"
    ]
  },
  {
    id: 3,
    title: "Project Management",
    description: "End-to-end project management ensuring timely delivery, budget control, and quality execution from inception to completion.",
    icon: "ClipboardList",
    features: [
      "Timeline management",
      "Resource allocation",
      "Quality control",
      "Risk management"
    ]
  },
  {
    id: 4,
    title: "Property Development",
    description: "Strategic property development services creating lasting value through innovative design and sustainable practices.",
    icon: "Home",
    features: [
      "Land development",
      "Urban planning",
      "Investment strategy",
      "Sustainable growth"
    ]
  },
  {
    id: 5,
    title: "General Contracting",
    description: "Professional contracting services including mining operations, petroleum supply, and industrial solutions.",
    icon: "Wrench",
    features: [
      "Mining operations",
      "Petroleum supply",
      "Industrial contracting",
      "Resource management"
    ]
  },
  {
    id: 6,
    title: "Consulting",
    description: "Expert consulting and advisory services for strategic procurement, compliance, and business development.",
    icon: "Briefcase",
    features: [
      "Strategic consulting",
      "Procurement advisory",
      "Compliance management",
      "Business development"
    ]
  },
  {
    id: 7,
    title: "IT Managed Services (IT MSP)",
    description: "Comprehensive IT managed services designed to help businesses maintain secure, reliable and efficient technology environments. We provide practical IT support and technology solutions tailored to the operational needs of businesses.",
    icon: "Server",
    features: [
      "IT Support & Helpdesk",
      "Microsoft 365 Administration",
      "Cloud & Infrastructure Support",
      "Network & Systems Administration",
      "Cybersecurity & Endpoint Protection",
      "Microsoft Azure & Cloud Services",
      "Identity & Access Management",
      "Remote Monitoring & Management"
    ]
  }
];

export const coreValues = [
  {
    id: 1,
    title: "Integrity",
    description: "Conducting business with the highest ethical standards, ensuring honesty and fairness in all our dealings.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Innovation",
    description: "Embracing innovative solutions and technologies to enhance efficiency and deliver exceptional results.",
    icon: "Lightbulb"
  },
  {
    id: 3,
    title: "Quality",
    description: "Delivering superior quality in every project, from construction to professional services.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Sustainability",
    description: "Dedicated to sustainable practices that contribute to long-term prosperity for business and communities.",
    icon: "Leaf"
  },
  {
    id: 5,
    title: "Customer Focus",
    description: "Prioritizing client satisfaction through responsive service and commitment to excellence.",
    icon: "Users"
  }
];

export const projects = [
  {
    id: 1,
    name: "Free State Water Infrastructure",
    category: "Water & Sewer",
    description: "Comprehensive water supply and sanitation system improvements across the Free State region.",
    image: "/images/projects/water-treatment.jpg",
    status: "Completed"
  },
  {
    id: 2,
    name: "Regional Road Network Enhancement",
    category: "Road Infrastructure",
    description: "Major road improvement project enhancing transportation infrastructure and safety.",
    image: "/images/projects/regional-road-network.jpg",
    status: "In Progress"
  },
  {
    id: 3,
    name: "Limestone Mining Operations",
    category: "Mining",
    description: "Sustainable limestone extraction supporting cement production and industrial growth.",
    image: "/images/projects/limestone-mining.jpg",
    status: "Ongoing"
  },
  {
    id: 4,
    name: "Petroleum Distribution Network",
    category: "Industrial Supply",
    description: "Establishment of bulk petroleum, oil, and gas supply chain for regional markets.",
    image: "/images/projects/petroleum.webp",
    status: "In Progress"
  },
  {
    id: 5,
    name: "R57 Road Upgrade Project",
    category: "Road Infrastructure",
    description: "Alakhe Conglomerate is participating as a sub-contractor in the ongoing R57 road upgrade project undertaken for the South African National Roads Agency SOC Limited (SANRAL), with Raubex Group serving as the main contractor.",
    image: "https://static.prod-images.emergentagent.com/jobs/f84364e6-7fd0-41c3-a044-339f46ecad27/images/7123f96e3631280951d2544ccc7bd2e085d31c6e8f3721bd8edcd19a4ec3f429.jpeg",
    status: "Ongoing",
    client: "SANRAL (South African National Roads Agency SOC Limited)",
    mainContractor: "Raubex Group",
    role: "Sub-contractor"
  },
  {
    id: 6,
    name: "Water Analysis & Municipal Compliance",
    category: "Water Quality & Compliance",
    description: "Alakhe Conglomerate has provided water analysis and water-quality monitoring services within Nketoana Local Municipality for nearly two years. The service includes coordinating water sample collection and laboratory analysis, monitoring and recording key water-quality results, maintaining documentation, and supporting municipal reporting and compliance requirements.",
    image: "/images/projects/water-analysis.jpg",
    status: "Completed",
    client: "Nketoana Local Municipality",
    serviceArea: "Nketoana Local Municipality, Free State",
    duration: "Nearly 2 years"
  },
  {
    id: 7,
    name: "Petsana Municipal Road Infrastructure Upgrade",
    category: "Road Infrastructure",
    description: "Municipal road infrastructure upgrade involving the resealing and rehabilitation of approximately 2 km of tar roads in Petsana, supporting improved road conditions and safer, more reliable local transportation.",
    image: "/images/projects/petsana-road.jpg",
    status: "Completed",
    client: "Nketoana Local Municipality",
    location: "Petsana, Reitz, Free State",
    tenderNumber: "NKT233/2022",
    scope: "Resealing of approximately 2 km of tar roads"
  },
  {
    id: 8,
    name: "Matoding, Petsana Water Project",
    category: "Water Infrastructure",
    description: "Participation in the Matoding, Petsana Water Project, delivering pipe-laying and water meter connection services to support the development and expansion of local water infrastructure.",
    image: "/images/projects/matoding-water.jpg",
    status: "Completed",
    contractor: "Bonke N Trading CC",
    location: "Matoding, Petsana, Free State",
    year: "2024",
    scope: "Pipe laying and water meter connection services"
  }
];

export const stats = [
  { 
    label: "Projects Completed", 
    value: 50, 
    suffix: "+",
    prefix: ""
  },
  { 
    label: "Happy Clients", 
    value: 35, 
    suffix: "+",
    prefix: ""
  },
  { 
    label: "Years Experience", 
    value: new Date().getFullYear() - 2018, 
    suffix: "+",
    prefix: ""
  },
  { 
    label: "Team Members", 
    value: 25, 
    suffix: "+",
    prefix: ""
  }
];

export const team = [
  {
    id: 1,
    name: "[Full Name]",
    role: "Managing Director",
    bio: "A short professional biography will appear here, highlighting leadership experience, sector expertise, and the vision this team member brings to Alakhe Conglomerate.",
    image: "https://static.prod-images.emergentagent.com/jobs/f84364e6-7fd0-41c3-a044-339f46ecad27/images/320d1648d7f0eefd46ab75c8d789cb80e2be04a9a2cc38f1f5ce3e87581b4832.jpeg",
    linkedin: "#"
  },
  {
    id: 2,
    name: "[Full Name]",
    role: "Operations Director",
    bio: "A short professional biography will appear here, covering operational leadership, delivery excellence, and the value this team member adds to every engagement.",
    image: "https://static.prod-images.emergentagent.com/jobs/f84364e6-7fd0-41c3-a044-339f46ecad27/images/f4b5f3bd7bf72d0a69d8af6166b9ba65808bd9a2faf5e32a9dfad2be88105c6c.jpeg",
    linkedin: "#"
  },
  {
    id: 3,
    name: "[Full Name]",
    role: "Head of Projects",
    bio: "A short professional biography will appear here, describing technical expertise, project delivery track record, and commitment to quality outcomes.",
    image: "https://static.prod-images.emergentagent.com/jobs/f84364e6-7fd0-41c3-a044-339f46ecad27/images/82a02fe0a880d175d949aaa3d34993ed5c04213dcb4ea79355020a05cc6ef001.jpeg",
    linkedin: "#"
  }
];

export const socialMedia = [
  { name: "LinkedIn", icon: "Linkedin", url: "https://za.linkedin.com/company/alakhe-conglomerate" },
  { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/alakhegh1/" }
];
